@if (!isStarted()) {
<div class="container-fluid" [ngClass]="{'p-0': mobileMode(), 'h-100': mobileMode()}" style="position: relative"
  [style.background-color]="clozeTestStyleModel().siteBackground">
  <div class="d-flex justify-content-center" [ngClass]="{'h-100': mobileMode()}">
    <div class="card" [ngClass]="{'container-fluid': mobileMode(), 'p-0': mobileMode()}" style="min-height: 570px;"
      [style.background-color]="clozeTestStyleModel().exerciseBackground"
      [ngStyle]="{'border': mobileMode() ? '0px' : '1px solid ' + clozeTestStyleModel().frameColor, 'border-radius': mobileMode()? '0px' : '0.25rem', 'width': mobileMode()? '' : '720px'}">
      <!-- mobile exercise header -->
      @if (mobileMode()) {
      <div class="onset-indicator">
        <img style="max-width: 100px;float: right;" [src]="cTestLogo()">
      </div>
      }
      <!-- body-->
      <div class="card-body" [ngClass]="{'card-mobile': mobileMode() }" [style.font-family]="clozeTestStyleModel().font"
        [style.font-size]="clozeTestStyleModel().fontSize">
        @if (clozeTestStyleModel().displayLogo && !mobileMode()) {
        <img class="floating-logo" [src]="cTestLogo()">
        }
        @if (validToken()) {
        <div>
          <h5 class="card-title text-center font-weight-bold">{{ 'ONSET-PORTAL-EXAM.DEMO.WELCOME' | translate }}</h5>
          <div class="row mt-2">
            <div class="col">
              <span>{{ 'ONSET-PORTAL-EXAM.DEMO.INTRO' | translate }}</span>
            </div>
          </div>

          <div class="text-center" style="margin-top: 40px;">
            <button class="btn" style="font-size: smaller;" [style.background-color]="cTestButtonColor()"
              (click)="startOnset()">{{ 'ONSET-PORTAL-EXAM.IDAS.START_ONSET' | translate }}</button>
          </div>
        </div>
        }

        <!-- error view -->
        @if (!validToken() && !isLoading()) {
        <div>
          <h5 class="card-title text-center font-weight-bold">{{ 'ONSET-PORTAL-EXAM.IDAS.NO_DATA' | translate }}</h5>
          <h5 class="card-title text-center font-weight-bold">
            {{ 'ONSET-PORTAL-EXAM.IDAS.CURRENT_USER_NO_DATA' | translate }}</h5>
        </div>
        }

        <!-- loading view -->
        @if (isLoading()) {
        <div>
          <h5 class="card-title text-center font-weight-bold">{{ 'ONSET-PORTAL-EXAM.IDAS.LOADING' | translate }}</h5>
        </div>
        }

      </div>
    </div>
  </div>
</div>
}

<!-- onset started -->
@if (isStarted()) {
<onset-cloze-test style="height: 100%;" [mobileMode]="mobileMode()" [clozeTestModel]="clozeTestModel()"
  [clozeTestStyleModel]="clozeTestStyleModel()" [showResult]="true" [showEndTestButton]="false" [lang]="lang()"
  (startTest)=onStartTest($event) (bookingInitialized)=onBookingInit($event) (testSaved)=onTestHasBeenSaved($event)
  (clozeTest)=onClozeTestCompleted() (testResult)=onTestResult($event)>
</onset-cloze-test>
}
